<template>
    <el-dialog title="Upload Files"
               closeable
               :visible.sync="visible"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               @close="$emit('input', false)"
               width="60%"
               custom-class="dialog-upload"
    >
        <div class="upload-queue">
            <div class="upload-queue-item" v-if="currentFile">
                <div class="upload-queue-file">
                    <i class="el-icon-loading"></i>
                    <div class="name">{{ currentFile.name }}</div>
                </div>
                <el-progress :percentage="percentage" :show-text="false"/>
            </div>
            <div class="upload-queue-item" v-for="(file, index) in fileList">
                <div class="upload-queue-file">
                    <i class="el-icon-document"></i>
                    <div class="name">{{ file.name }}</div>
                </div>
                <el-progress :percentage="0" :show-text="false"/>
            </div>
        </div>
        <div class="uploader" v-if="showUploader">
            <el-upload
                class="upload-demo"
                drag
                action="/"
                multiple
                :on-change="handleChange"
                :show-file-list="false"
                :http-request="onUpload"
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Drag the file to here，Or<em>Click to upload</em></div>
                <div class="el-upload__tip text-center" slot="tip">Only PDF files can be uploaded, and they should not exceed 10mb</div>
            </el-upload>
        </div>
    </el-dialog>
</template>

<script>
import ApiService from "../../utils/ApiService";

export default {
    name: "DialogUploadReport",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        dir: {
            type: Number | String,
            default: 0
        },
        action: {
            type: String,
            default: '/buildium/associations/files'
        }
    },
    data() {
        return {
            visible: false,
            fileList: [],
            uploading: false,
            currentFile: null,
            percentage: 0,
            showUploader: true
        }
    },
    watch: {
        value(val) {
            this.visible = val;
        }
    },
    methods: {
        handleChange() {

        },
        uploadQueue() {
            if (this.uploading) {
                return false;
            }

            if (this.fileList.length) {
                this.currentFile = this.fileList.shift();
                const formData = new FormData();
                formData.append('file', this.currentFile);
                formData.append('dir', this.dir);

                this.uploading = true;
                ApiService.post(this.action, formData, {
                    timeout: 0,
                    headers: {'Content-type': 'multipart/form-data'},
                    onUploadProgress: evt => {
                        //console.log(evt);
                        this.percentage = (evt.loaded / evt.total) * 100;
                    }
                }).then(response => {

                }).catch(reason => {
                    this.$message.error(reason.message);
                }).finally(() => {
                    this.uploading = false;
                    this.percentage = 0;
                    this.currentFile = null;
                    setTimeout(this.uploadQueue, 1000);
                });
            } else {
                this.currentFile = null;
                this.showUploader = true;
                this.$emit('complete', false);
            }
        },
        onUpload(e) {
            this.fileList.push(e.file);
            this.uploadQueue();
            this.showUploader = false;
            return false;
        },
    }
}
</script>

<style scoped>

</style>